<template>
  <div class="header-box" >
    <div class="menu-box mobile_hide">
      <!-- 菜單 -->
      <ul class="menu-nav">
        <!-- left menu -->
        <li class="menu-logo hide_1440">
          <router-link to="/home"><img :src="logoImage" width="100%"/></router-link>
        </li>
        <li class="menu-nav-li">  <a href="https://shop.8way.com.tw/" target="_blank" class="shopping menu-nav-a">　{{ $t('home_000') }}</a></li>
        <li class="menu-nav-li" v-for="(item,index) in menuData" :key="index" v-if="index<menuData.length/2">
          <a class="menu-nav-a" v-if="item.kindList.length>0" :class="{'nav-black-a':item.kindList.length>0}">{{ item.name }}
            <i class="down"></i>
          </a>
          <router-link class="menu-nav-a" :to="item.path" v-else>{{ item.name }}
          </router-link>
          <div class="menu-nav-dropdown" v-if="item.kindList.length>0">
            <ul :class="{'menu-350':locale=='en','menu-250':locale=='jpa'}">
              <li v-for="(item2,index2) in item.kindList" :key="index2">
                <router-link class="dropdown-a" :to="item.path+'/'+item2.id">{{ item2.name }}</router-link>
              </li>
            </ul>
          </div>
        </li>
            <li class="menu-nav-li" v-for="(item,index) in menuData" :key="index" v-if="index>=menuData.length/2">
          <a class="menu-nav-a" v-if="item.kindList.length>0" >{{ item.name }}
            <i class="down"></i>
          </a>
          <router-link class="menu-nav-a" :to="item.path" v-else>{{ item.name }}
          </router-link>
          <div class="menu-nav-dropdown" v-if="item.kindList.length>0">
            <ul >
              <li v-for="(item2,index2) in item.kindList" :key="index2">
                <router-link class="dropdown-a" :to="item.path+'/'+item2.id">{{ item2.name }}</router-link>
              </li>
            </ul>
          </div>
        </li>
        <li class="menu-nav-li">  <a href="https://www.bafangdumpling.com/" target="_blank" class="menu-nav-a">{{ $t('home_001') }}</a></li>
        <li class="menu-nav-li">  <a href="/contactfranchise" target="_blank" class="menu-nav-a">{{ $t('home_002') }}</a></li>
        <!-- center logo -->


        <!-- right menu -->
     <!--  <li class="menu-nav-li"> <a href="/ESG" class="menu-nav-a">{{ $t('home_02') }}</a></li>-->
       <!--  <li class="menu-nav-li"> <a href="/investor" target="_blank" class="menu-nav-a">{{ $t('home_00') }}</a></li>
        <li class="menu-nav-li"> <a href="/setAim" target="_blank" class="menu-nav-a">{{ $t('home_01') }}</a></li>-->
      </ul>
      <!-- 右邊部份 -->
      <div class="lang-me-message">
        <!-- 語言 -->

        <!-- 搜索門市 -->
        <router-link class="search-shop-btn" to="/store"><i class="address-icon"></i>{{ $t('home_5_1') }}</router-link>

       <!--<a href="https://shop.8way.com.tw/" target="_blank" class="account"></a>-->
        <div class="lang-box">
          <a class="lang-a">
            <span v-if="locale=='tw'">{{ $t('lang_1') }}</span>
            <span v-else-if="locale=='cn'">{{ $t('lang_2') }}</span>
            <span v-else-if="locale=='en'">{{ $t('lang_3') }}</span>
            <span v-else>{{ $t('lang_4') }}</span>
            <i class="down"></i>
          </a>
          <div class="lang-dropdown">
            <ul>
              <li v-for="(item,i) in langData" :key="i">
                <a class="dropdown-a" @click="changeLang(item)">
                  <span v-if="item=='tw'">{{ $t('lang_1') }}</span>
                  <span v-else-if="item=='cn'">{{ $t('lang_2') }}</span>
                  <span v-else-if="item=='en'">{{ $t('lang_3') }}</span>
                  <span v-else>{{ $t('lang_4') }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="pc_hide">
      <div class="menu-btn pc_hide" id="menuBtnId" @click="showPopup()">
        <a><i></i></a>
      </div>
      <div class="menu-logo">
        <router-link to="/home"><img :src="logoImage" width="100%"/></router-link>
      </div>
    <div class="menu-icon">
         <a href="https://shop.8way.com.tw/" target="_blank" class="shopping"></a> </div>
        <a href="/store" class="address"></a>

    </div><!--:class="{isSafari:$store.state.isSafari}"-->
    <div id="headerboxs" class="menu-box menu-mobile-box pc_hide" v-if="isShowPopup"  >
      <div class="menu-box-top">
        <a class="back" @click="resetMobileMenu()" v-if="mobileActive!=0"></a>
        <div class="name" v-if="mobileActive!=0">{{ mobileActiveName }}</div>
        <a class="close-btn" @click="closePopup()"></a>
      </div>
      <div class="menu-nav-conten">
        <ul class="menu-nav">
           <li class="menu-nav-li" v-for="(item,index) in mobileMenuData" :key="index">
            <a class="menu-nav-a" @click="mobileTab(index)">{{ item.name }}
              <em></em>
            </a>
          </li>
          <li>
              <p><a href="https://www.bafangdumpling.com/"  >{{ $t('home_001') }}</a></p>
              <p><a href="/contactfranchise" target="_blank">{{ $t('home_002') }}</a></p>
            </li>
<!--
          <li class="menu-nav-li">
              <a href="/investor" target="_blank" class="menu-nav-a">{{ $t('home_00') }}
              <em></em>
           </a>
          </li>

           <li class="menu-nav-li">
              <a href="/setAim" target="_blank" class="menu-nav-a">{{ $t('home_01') }}
              <em></em>
           </a>
          </li> -->


        </ul>
        <div class="menu-information" v-if="mobileActive==0">
          <ul>
            <li>
              <p>{{ $t('home_47') }}</p>
              <p>0800-898-000<br>周一至周五9:00~18:00 <br>(國定假日與六日除外)</p>

            </li>
            <li>
              <p>{{ $t('home_48') }}</p>
              <p>{{ $t('home_49') }}</p>
            </li>
              <li>
            <p><a href="/contactUs" style="color:#0078F9;" >{{$t("home_4")}}</a></p>
          </li>
          </ul>
        </div>
      </div>

      <div class="mobile-lang-box">
        <div class="lang-a">
          <span :class="{'active':locale=='tw'}" @click="changeLang('tw')">中 <em>繁</em> </span>
          <span :class="{'active':locale=='cn'}" @click="changeLang('cn')">中 <em>簡</em> </span>
          <span :class="{'active':locale=='en'}" @click="changeLang('en')">E</span>
          <span :class="{'active':locale=='jpa'}" @click="changeLang('jpa')">日</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '../config/api'
import logo from '@/assets/images/logo.svg'

export default {
  name: 'Header',
  inject: ['reload'],
  data() {
    return {
      logoImage: logo,
      locale: 'tw',
      allLangData: ['tw', 'cn', 'en', 'jpa'],
      langData: [],
      menuData: [],
      mobileMenuData: [],
      mobileActive: 0,
      mobileActiveName: '',
      menuDataHide: false,
      isShowPopup: false,
      typeData:[],
    }
  },
  created() {
    let lang = '';
    let isSession = false;
    if(sessionStorage.getItem('lang')){
      lang = sessionStorage.getItem('lang');
      isSession = true;
    }else{
      lang = navigator.languages? navigator.languages[0] : (navigator.language || navigator.userLanguage);
      lang = lang.toLowerCase();
      isSession = false;
    }

    if ((lang == 'CH' && isSession) || (lang == 'zh-cn' && !isSession)) {
      this.changeLang('cn');
    }else if ((lang == 'TR' && isSession) || ((lang == 'zh-tw' || lang == "zh-hk") && !isSession)) {
      this.changeLang('tw');
    }else if ((lang == 'JA' && isSession) || (lang == 'ja' && !isSession)) {
      this.changeLang('jpa');
    }else {
      this.changeLang('en');
    }
  },
  mounted() {
    this.getTypeList();
  },
  methods: {
    changeLang(value) {
      if (value == 'cn') {
        sessionStorage.setItem('lang', 'CH');
      } else if (value == 'tw') {
        sessionStorage.setItem('lang', 'TR');
      } else if (value == 'jpa') {
        sessionStorage.setItem('lang', 'JA');
      } else {
        sessionStorage.setItem('lang', 'EN');
      }
      this.locale = value;
      this.$i18n.locale = value;
      this.langData = [];
      for(let i = 0; i < this.allLangData.length; i++) {
        if (this.allLangData[i] != this.locale) {
          this.langData.push(this.allLangData[i]);
        }
      }
      this.closePopup();
      this.GetHeadList();
      this.reload();
      return;
    },
    //最新消息菜单
    getTypeList:function(){
      this.$fetch(API.GetTypeList).then((response) => {
          if(response.code == 200){
            this.typeData = response.data;
            this.GetHeadList();
          }
      });
    },

    GetHeadList: function () {
      this.$fetch(API.GetWebHeadList).then((response) => {
        if (response.code == 200) {
          let data = response.data;
          if (document.body.clientWidth <= 1080) {
            data.push({
              name:  this.$i18n.t('home_41'),
              path: "/",
              kindList: [
                {
                  name: this.$i18n.t('home_58'),
                  herf: "https://www.bafangdumpling.com/",
                },
                {
                  name: this.$i18n.t('home_57'),
                  herf: "https://www.fjveggie.com.tw/",

                },
                {
                  name: this.$i18n.t('home_56'),
                  herf: "https://www.buygood.com.tw",

                },

                {
                  name: this.$i18n.t('home_43'),
                  herf: "https://www.facebook.com/8wayTW",
                },
                {
                  name: this.$i18n.t('home_45'),
                  herf: "https://msn.sgs.com/VIP_zone.aspx?CstNo=NjZVQ3NZMStGQ21OTExJeDlza0NaUT09T09#bg",

                },
                {
                  name: this.$i18n.t('home_01'),
                  herf: "/setAim",

                }
              ]
            })

            for (let i = 0; i < data.length; i++) {
              if (data[i].id == '03') {
                data[i].kindList.push(
                  {
                    name: this.$i18n.t('company_1'),
                    tolink: true,
                    path: '/aboutUs',
                    id: 'top1'
                  },
                  {
                    name: this.$i18n.t('company_2'),
                    tolink: true,
                    path: '/aboutUs',
                    id: 'top2'
                  },
                  {
                    name: this.$i18n.t('company_3'),
                    tolink: true,
                    path: '/aboutUs',
                    id: 'top3'
                  },
                  {
                    name: this.$i18n.t('company_4'),
                    tolink: true,
                    path: '/aboutUs',
                    id: 'top4'
                  },
                  {
                    name: this.$i18n.t('company_5'),
                    tolink: true,
                    path: '/aboutUs',
                    id: 'top5'
                  },
                  {
                    name: this.$i18n.t('company_9'),
                    tolink: true,
                    path: '/aboutUs',
                    id: 'top8'
                  }
                )
              }

              if(data[i].id == '04'){
                for(let j=0;j<this.typeData.length;j++){
                    data[i].kindList.push({
                      name: this.typeData[j].name,
                      tolink: true,
                      path: '/news',
                      id: this.typeData[j].id,
                    })
                }
              }

              if (data[i].id == '05') {
                data[i].kindList.push(
                  {
                      name: this.$i18n.t('contact_1'),
                      tolink: true,
                      path: '/contactUs',
                      id: 1
                  },
                  {
                    name: this.$i18n.t('contact_2'),
                    tolink: true,
                    path: '/contactUs',
                    id: 2
                  },
                  {
                    name: this.$i18n.t('contact_3'),
                    tolink: true,
                    path: '/contactUs',
                    id: 3
                  },
                  {
                    name: this.$i18n.t('contact_4'),
                    herf:'https://www.104.com.tw/company/1a2x6bi08r?jobsource=checkc'
                  }
                )
              }

            }
          }
          this.menuData = data;
          this.mobileMenuData = data;
          this.mobileActive = 0;
        }
      });
    },
    mobileTab: function (i) {
      if (!this.mobileMenuData[i].kindList || this.mobileMenuData[i].kindList.length == 0) {
        /*this.mobileActive==0*/
        if(this.mobileMenuData[i].path == '/Product') {
          this.$router.push({path: this.mobileMenuData[i].path + '/' + this.mobileMenuData[i].id});
          this.isShowPopup = false;
          $('body').removeClass('no-scroll');
        } else if(this.mobileMenuData[i].path == '/investor') {
          this.$router.push({path: this.mobileMenuData[i].path + '/' + this.mobileMenuData[i].id});
          this.isShowPopup = false;
          $('body').removeClass('no-scroll');
        }else if(this.mobileMenuData[i].path == '/ESG') {
          this.$router.push({path: this.mobileMenuData[i].path + '/' + this.mobileMenuData[i].id});
          this.isShowPopup = false;
          $('body').removeClass('no-scroll');
        }
        else {
          if(this.mobileMenuData[i].path && !this.mobileMenuData[i].id) {
            this.$router.push({path: this.mobileMenuData[i].path});
          }else if(this.mobileMenuData[i].herf) {
            location.href = this.mobileMenuData[i].herf;
          }else if(this.mobileMenuData[i].tolink) {
            this.$router.push({path: this.mobileMenuData[i].path + '/' + this.mobileMenuData[i].id});
          }
          this.isShowPopup = false;
          $('body').removeClass('no-scroll');
        }
      }else {
        this.mobileActive = 1;
        this.mobileActiveName = this.mobileMenuData[i].name;
        this.mobileMenuData = this.mobileMenuData[i].kindList;
        $('body').addClass('no-scroll');
      }
    },


    /*切换外部链接菜单*/
    mobileTab2() {
      this.menuDataHide = true;
    },
    //重设菜单
    resetMobileMenu() {
      this.mobileActive = 0;
      this.mobileMenuData = this.menuData;
    },
    //关闭菜单
    closePopup(){
      this.isShowPopup = false;
      this.mobileActive = 0;
      this.mobileMenuData = this.menuData;
      $('body').removeClass('no-scroll');
    },
    //展示菜单
    showPopup(){
      $('body').addClass('no-scroll');
      this.mobileActive = 0;
      this.mobileMenuData = this.menuData;
      this.isShowPopup = true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .show_1440{
      display: none;
  }
.header-box {
  width: 100%;
  background: #ffffff;
  position: fixed;
  z-index: 1001;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05);
  text-align: center;
  left: 0;
  top: 0;
  height:88px;

  .menu-box {
    margin: 0 auto;
    padding: 12px 30px;

    .menu-nav {
      text-align: center;
      padding: 0;
      display: inline-block;
     /* padding-left: 404px;*/

      .menu-nav-li {
        display: inline-block;
        position: relative;
        &>.router-link-active{
          color: #cb1a19;
          font-weight: 500;
        &.nav-black-a{
           color: #261A16;
           font-weight: normal;
         }
        }
        &:hover{
          .menu-nav-a {
            color: #cb1a19;
            font-weight: 500;
          /*  .down {
              background: url('../../assets/images/angle-left-solid-red.svg') no-repeat center center;
            }*/
            &.nav-black-a{
               color: #261A16;
               font-weight: normal;
            }
          }
        }
        .shopping{

        display: inline-block;
        background: url(../../assets/images/shopping_icon.svg) no-repeat left;

      }
        .menu-nav-dropdown {
          position: absolute;
          /* left:30%;*/
          left: 50%;
          margin-left: -100px;
          padding-top: 22px;
          display: none;

          &:hover {
            display: block;
          }

          ul {
            width: 200px;
            background: #ffffff;
            border-radius: 35px;
            padding: 18px 0;
            box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
            overflow: hidden;

            li {
              a {
                font-size: 17px;
                /*line-height: 46px;*/
                display: block;
                padding: 8px 40px;
                text-align: left;
                cursor: pointer;
                letter-spacing: 1.59px;
                &:hover,&.router-link-active{
                  font-weight: 500;
                  background: #f8f8f8;
                }
              }
            }
          &.menu-350{
            width: 350px;
           }
           &.menu-250{
              width: 250px;
            }
          }
        }

        .menu-nav-a {
          font-size: 18px;
          line-height: 64px;
           padding: 0 10px; /*調整navbar項目間距*/
          position: relative;
          display: block;
          cursor: pointer;
          letter-spacing: 1px;

          &:hover + .menu-nav-dropdown {
            display: block;
          }

          .down {
            width: 15px;
            height: 15px;
            display: inline-block;
            vertical-align: middle;
            background: url('../../assets/images/angle-left-solid.svg') no-repeat center center;
          }
          &:hover{
             color: #cb1a19;
             font-weight: 500;
           }
        }
      }

      .menu-logo {
        display: inline-block;
        width: 160px;
        height: 64px;
        padding: 0 10px;

        a {
          display: block;
          cursor: pointer;
        }
        &.show_1440{
           display: none;
         }
      }
    }

    .lang-me-message {
         position: absolute;
         right: 110px;
         text-align: right;
          display: inline-block;
          position:relative;
          right:auto;


      .lang-box {
        display: inline-block;
        position: relative;

        &:hover {
          .lang-a {
            color: #cb1a19;

            .down {
              background: url('../../assets/images/angle-left-solid-red.svg') no-repeat center center;
            }
          }
        }

        .lang-dropdown {
          position: absolute;
          left: 50%;
          margin-left: -70px;
          padding-top: 22px;
          display: none;

          &:hover {
            display: block;
          }

          ul {
            width: 200px;
            background: #ffffff;
            border-radius: 35px;
            padding: 18px 0;
            box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
            overflow: hidden;

            li {
              a {
                font-size: 17px;
              /*  line-height: 44px;*/
                display: block;
                padding: 8px 30px;
                text-align: left;
                cursor: pointer;
                letter-spacing: 1.59px;

                &:hover {
                  background: #f8f8f8;
                }
              }
            }
          }
        }

        .lang-a {
          font-size: 18px;
          line-height: 64px;
          position: relative;
          padding: 0 15px;
          display: block;
          cursor: pointer;
          span{
            color: #261A16;
            font-size: 18px;
            font-weight: 500;
            letter-spacing: 1.35px;
            &:hover{
               color: #CF0902;
             }
          }
          &:hover + .lang-dropdown {
            display: block;
          }

          .down {
            width: 15px;
            height: 15px;
            display: inline-block;
            margin-left: 0;
            vertical-align: middle;
            background: url('../../assets/images/angle-left-solid.svg') no-repeat center center;
          }
        }
      }

      .search-shop-btn {
        display: inline-block;
        font-size: 18px;
        line-height: 25px;
        color: #fff;
        background: #cb1a19;
        padding: 14px 24px;
        margin: 5px 0 4px 0;
        border-radius: 55px;
        cursor: pointer;
        letter-spacing: 1.69px;
         white-space: nowrap;
        .address-icon {
          width: 27px;
          height: 25px;
          background: url(../../assets/images/address-icon.svg) no-repeat center;
          display: inline-block;
          vertical-align: top;
          margin-right: 5px;
          background-size: 100%;
        }

      }
      .shopping{
        height: 35px;
        width: 35px;
        margin-left: 12px;
        display: inline-block;
        background: url(../../assets/images/shopping_icon.svg) no-repeat center;
        vertical-align: middle;
      }
      .account{
        height: 35px;
        width: 35px;
        margin-left: 10px;
        display: inline-block;
        background: url(../../assets/images/account_icon.svg) no-repeat center;
        vertical-align: middle;
      }
    }
  }

  a {
    color: #261A16;
    caret-color: rgba(0, 0, 0, 0);
  }
}
@media (max-width: 1780px) {
  .header-box .menu-box .lang-me-message{
    right: 2%;
  }
}
@media (max-width: 1580px) {
  .header-box .menu-box {
      margin-left: 12%;
      text-align: left;
    .lang-me-message{
      margin-left: 0;
    }
  }

}
@media (max-width: 1440px) {
  .header-box .menu-box{
    display:flex;
    align-items:center;
    justify-content:center;
    margin-left:0;
  }
  .header-box .menu-box .menu-nav .menu-nav-li .menu-nav-a{
    padding: 0 18px;
    font-size: 16px;
     flex:1;
  }
  .header-box .menu-box .lang-me-message .lang-box .lang-a,
  .header-box .menu-box .lang-me-message .search-shop-btn,
  .header-box .menu-box .lang-me-message .lang-box .lang-a span
  {
    font-size: 16px;

  }
  .header-box .menu-box .menu-nav .menu-nav-li .menu-nav-dropdown ul li a,
  .header-box .menu-box .lang-me-message .lang-box .lang-dropdown ul li a
  {
    font-size: 15px;

  }

  .header-box .menu-box .menu-nav .menu-logo{
    &.show_1440{
        display: inline-block;
        padding-left:0;
     }
    &.hide_1440{
       display: none;
     }
  }
}
@media (max-width: 1180px) {
  .header-box .menu-box .menu-nav .menu-nav-li .menu-nav-a{
    padding: 0 12px;

  }
}

/*手机*/
@media (max-width: 1080px) {

  .header-box {
    height: 60px;
    line-height: 60px;
    padding: 0 18px;
    .menu-box {
      padding: 0;
      width: 100%;
      height:100%;
      position: fixed;
      top: 0;
      left: 0;
      background: rgba(255, 255, 255, 0.95);
      z-index: 999;
      padding-right: 0;
      -webkit-transition: all 100ms ease-out;
      -moz-transition: all 100ms ease-out;
      -ms-transition: all 100ms ease-out;
      -o-transition: all 100ms ease-out;
      transition: all 100ms ease-out;
      overflow-y: auto;
      margin-left:0;
      .menu-nav-conten {
        width: 100%;
        min-height: calc(100vh - 132px);
      }
      .menu-nav {
        width: 100%;
        padding: 30px 0;
        .menu-nav-li {
          width: 100%;
          .menu-nav-a {
            line-height: 24px;
            padding:0;
            .down {
              display: none;
            }
          }
          em {
            width:6px;
            height: 14px;
            background: url(../../assets/images/menuRight.png) no-repeat right center;
            position: absolute;
            right: 30px;
            margin-top: 5px;
            background-size: 100%;
          }
        }
      }
    }

    .menu-btn {
      height: 36px;
      width: 36px;
      border-radius: 18px;
      background-color: #CF0902;
      display: inline-block;
      position: absolute;
      top: 12px;

      a {
        display: block;
        width: 100%;
        height: auto;
        padding-top: 6px;

        i {
          width: 22px;
          height: 22px;
          background: url('../../assets/images/menu.svg') no-repeat center center;
          background-size: 100%;
          margin: auto;
          display: block;
        }
      }

    }

    .menu-logo {
      text-align: center;
      margin: auto;
      width: 100%;
      height: auto;
      display: inline-block;

      a {
        width: 113px;
        height: auto;
        display: inline-block;

        img {
          width: 100%;
          height: 100%;
          background-size: 100%;
        }
      }

      &.mobile_hide {
        display: none !important;
      }

    }
    .menu-icon{
      width: auto;
      position: absolute;
      right:12px;
      top:10px;
        a{
          height: 30px;
          width: 30px;
          display: inline-block;
        }
        .address{
          background: url(../../assets/images/address-iconM.svg) no-repeat;
        }
        .shopping{
          background: url(../../assets/images/shopping_iconM.svg) no-repeat;
        }

    }
    .close-btn {
      width: 22px;
      height: 22px;
      background: url('../../assets/images/Icon_Home_Menu_Back@2x.png') no-repeat center center;
      background-size: 100%;
      display: block;
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }
  .menu-information {
    padding: 0 34px 40px 34px;

    ul {
      padding-left: 0;
      border-top: 1px solid #261A16;
      padding-top: 38px;

      li {
        text-align: center;

        p {
          line-height: 2;
          font-size: 14px;

          &:nth-child(1) {
            font-size: 16px;
            font-weight: 500;
          }

          &:nth-child(2) {
            margin-bottom: 29px;
          }
        }
      }
    }
  }
  .mobile-lang-box {
    width: 100%;
    height: 66px;
    line-height: 66px;
    text-align: center;
    background: #fff;
    box-shadow: 20px 19px 25px 30px rgba(0, 0, 0, 0.05);

    span {
      display: inline-block;
      font-size: 18px;

      &:after {
        content: '|';
        display: inline-block;
        padding: 0 10px;
        color: #261A16;
      }

      &.active {
        color: #CF0902;
      }

      &:last-child {
        &:after {
          display: none;
        }
      }

      em {
        font-size: 11px;
        font-style: normal;
      }
    }
  }
  .menu-box-top {
    width: 100%;
    height: 66px;
    line-height: 66px;
    position: relative;

    .back {
      width: 8px;
      height: 14px;
      background: url(../../assets/images/menuLeft.png) no-repeat left center;
      display: inline-block;
      position: absolute;
      left: 30px;
      top: 23px;
      background-size: 100%;
    }

    .close-btn {
      position: absolute;
      right: 23px;
    }

    .name {
      width: 100%;
      height: auto;
      color: #261A16;
      font-size: 18px;
      font-weight: 500;
      display: inline-block;
      margin: auto;
      text-align: center;
      padding: 0 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/default/Header.vue